import { Col, Row } from "reactstrap";
import { useEmployeeProfile } from "../../../../../hooks/useEmployeeProfile";
import EmployeeInfoCard from "../../EmployeeInfoCard";

const EmployeeExitTab = () => {
  const { employeeProfileDetails } = useEmployeeProfile();
  const employeeExitInfo = employeeProfileDetails?.user_exit_info;

  // If no user exit info or it's not an array, return nothing
  if (
    !employeeExitInfo ||
    !Array.isArray(employeeExitInfo) ||
    employeeExitInfo.length === 0
  ) {
    return null;
  }

  const exitRecord = employeeExitInfo[0];

  return (
    <Row>
      {employeeExitInfo && (
        <Col md="6">
          <EmployeeInfoCard
            bodyClassName="p-3"
            title="Exit Info"
            entity={exitRecord}
            omitKeys={["id","user_id","exit_by","created_at","updated_at"]}
          />
        </Col>
      )}
    </Row>
  );
};

export default EmployeeExitTab;
